import { useEffect, useState } from "react";
import { getCategoryDomId } from "~/utils/category";

export function useActiveAnchor(
  elementIds: string[],
  offset: number,
): string | null {
  const [currentElementId, setCurrentElementId] = useState<string | null>(null);

  useEffect(() => {
    const elements = elementIds
      .map((id) => document.getElementById(getCategoryDomId(id)))
      .filter((el): el is HTMLElement => Boolean(el));

    function handleScroll() {
      for (let i = elements.length - 1; i >= 0; i--) {
        const el = elements[i];
        if (Math.sign(el.getBoundingClientRect().top - offset) === -1) {
          if (currentElementId !== el.id) {
            setCurrentElementId(el.id);
          }
          return;
        }
      }
      setCurrentElementId(null);
    }

    document.addEventListener("scroll", handleScroll);

    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  });

  return currentElementId;
}
